// What the "From Garmin" item in the recordings page's Import menu does, from the signed-in user
// (window.user, see User#as_json): open the past-activities dialog, say an import is already on its
// way (one per Garmin connection), or send the user to connect Garmin first.
export type GarminImportOption = 'dialog' | 'requested' | 'connect';

interface GarminImportUser {
  garmin_connected?: boolean | null;
  garmin_backfill_requested?: boolean | null;
}

export function garminImportOption(user: GarminImportUser | null | undefined): GarminImportOption {
  if (!user?.garmin_connected) return 'connect';

  return user.garmin_backfill_requested ? 'requested' : 'dialog';
}
